import { accessToken } from '../../../configuration/tokenHandling/accessToken';
import { isEmpty } from 'es-toolkit/compat';

export const prepareHeaders = (headers: Headers) => {
    headers.set('Content-Type', 'application/json');

    const token = accessToken.getAccessToken();
    if (token !== null) {
        headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
};

export const trimmedOrUndefined = (text: string | undefined) => {
    if (text === undefined) return undefined;
    const trimmed = text.trim();
    return isEmpty(trimmed) ? undefined : trimmed;
};
